/* =========================================================================
   main.tsx — Entry point. Mounts the React app.
   ========================================================================= */

// React imported via JSX transform
import React from "react";
import ReactDOM from "react-dom/client";
// estate-callback captures an inbound /auth/callback token hash
// synchronously at import — keep this import above the app tree.
import { consumeEstateHandoff } from "./estate-callback";
import Root from "./app";
import { captureTenureIntro } from "./tenure-entrance";

void consumeEstateHandoff().catch(() => {
  // Keep startup alive without exposing rejected session/token material.
  console.warn("[estate-sso] inbound handoff bootstrap failed");
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js").catch(() => {});

  // No-stale-bundle-after-deploy: when a newly-installed SW takes control (it calls skipWaiting +
  // clients.claim), reload ONCE so open pages pick up the fresh bundle. The module-level `refreshing`
  // flag prevents a reload loop (controllerchange can fire more than once). We do NOT reload on every
  // load — only on an actual controller change (a new SW activating), so passcode/offline flows are
  // untouched on a normal load.
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("No #root element found");
captureTenureIntro();
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
